import { useAuth } from '../lib/auth';
import Skeleton from './Skeleton';
import { useFetchInstitutionLicenses } from '../lib/fetches.ts';
import { BadgeSkeleton } from './badge/Badge.tsx';
import { LicenseBadge } from './badge/LicenseBadge.tsx';

export default function Avatar() {
    const { user, isLoading } = useAuth({ tmp: 'Avatar' });

    const { data: licenses, isLoading: isLoadingLicenses } =
        useFetchInstitutionLicenses();
    const activeLicense = licenses?.active;

    return (
        <div className="flex items-center">
            {isLoading ? (
                <Skeleton className="mr-3 aspect-square h-11 w-11 flex-shrink-0 rounded-full" />
            ) : (
                <img
                    src={user?.avatar}
                    alt={user?.full_name ?? 'Profilová fotka'}
                    width={44}
                    height={44}
                    className="mr-3 aspect-square h-11 w-11 flex-shrink-0 rounded-full object-cover object-top"
                />
            )}
            <span className="flex w-full flex-col text-lg font-medium">
                {isLoading && (
                    <Skeleton className="block h-4 w-full rounded-xl" />
                )}
                <span>{user?.full_name}</span>

                {isLoadingLicenses ? (
                    <BadgeSkeleton />
                ) : (
                    <LicenseBadge license={activeLicense!} />
                )}
            </span>
        </div>
    );
}
